<template>
    <div class="tabs">
        <img class="logo" src="@/assets/logo-text.png" alt="" @click="clickImg" />
        <div class="tabs-list">
            <div class="tabs-item" v-for="(item, index) in titleList" :key="index" :class="{active: index === activeIndex}" @click="onSkip(item)">{{item.title}}</div>
        </div>
        <!-- <div class="login">
            <div v-if="userInfo&&userInfo?.username" class="username">{{ userInfo.username }}</div>
            <div v-else @click="onLogin" class="login-btn">登录</div>
        </div> -->
    </div>
</template>
<script setup name="home-Tabs">
import { ref, defineProps, onMounted, getCurrentInstance } from 'vue'
const { proxy } = getCurrentInstance()
// 接收props传参
const props = defineProps({
    activeIndex: {
        type: Number,
        default: 0,
    }
})
// 定义titleList
const titleList = ref([
    { title: '首页', path: '/' },
    { title: '解决方案', path: '/TotalSolution' },
    { title: '项目案例', path: '/ProjectCase' },
    { title: '生态合作', path: '/EcologicalCooperation' },
    // { title: '行业新闻', path: '/TradeNews' },
    { title: '加入我们', path: '/JoinWe' },
    { title: '关于我们', path: '/AboutView' },
    // { title: '补丁下载', path: '/PatchDownload' }
])
// 定义activeIndex
const activeIndex = ref(0)
// 用户信息
const userInfo = ref({})
onMounted(() => {
    activeIndex.value = props.activeIndex // 获取activeIndex
    // 在vuex中获取用户信息
    userInfo.value = proxy.$store.state.userInfo || {}
})
//点击logo跳转首页
const clickImg = () => {
    proxy.$router.push('/')
}
// 点击tab跳转相应页面
const onSkip = (item) => {
    proxy.$router.push(item.path)
}
// 点击登录跳转登录页
// const onLogin = () => {
//     proxy.$router.push('/login')  
// }
</script>
<style scoped lang="scss">
.tabs {
    width: 86vw;
    height: 5.625rem;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.6rem 2rem;
    margin: 0 auto;
    .logo {
        height: 4rem;
        cursor: pointer;
    }
    .tabs-list {
        width: 60%;
        padding: 0.8rem 2rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 1.5rem;
        border-radius: 0.6rem;
        color: rgba(37, 43, 92, 1);
        .tabs-item {
            cursor: pointer;
            height: 4rem;
            position: relative;
            // border-bottom: 4px solid transparent;
            &::after {
                content: '';
                display: block;
                width: 100%;
                height: 4px;
                background: transparent;
                border-radius: 0.3rem;
                transition: width 0.4s;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }
        .active::after {
            background: #C0252B;
        }
    }
    .login {
        display: none;
        width: 10rem;
        height: 2.8rem;
        border: 1px solid #9c9d9c;
        border-radius: 1.1rem;
        background: #010101;
        .username {
            height: calc(2.8rem - 2px);
            line-height: calc(2.8rem - 2px);
            color: #666;
            font-size: 1.25rem;
            cursor: pointer;
        }
        .login-btn {
            height: calc(2.8rem - 2px);
            line-height: calc(2.8rem - 2px);
            color: #fff;
            font-size: 1.25rem;
            cursor: pointer;
        }
    }
}
</style>